.handle{display:flex}.handle mat-icon{cursor:move}.spacer{width:24px}
/*# sourceMappingURL=compare-answers.component.css.map */
